export default __webpack_public_path__ + "static/media/house.af062091.svg";